// @flow
import React from "react";
import styled, { css } from "styled-components";
import { Cup as CupIcon } from "../Icons/Tournaments";
import Gettext from "../common/Gettext";
import Money from "../Money";
import HowMuchInBucks from "../HowMuchInBucks";
import Kuchka, { tournamentCurrency } from "../Icons/Kuchka";

const Table = styled.div`
  display: table;
  border-collapse: separate;
  border-spacing: 0 4px;
  width: 100%;
  margin-bottom: 30px;
`;

const TableTitles = styled.div`
  display: table-row;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  color: #99959d;
`;

const Title = styled.div`
  display: table-cell;
  ${props =>
    props.type === "number" &&
    css`
      padding-left: 10px;
    `}
  ${props =>
    props.resolution === "onlyDesktop" &&
    css`
      @media (max-width: 959px) {
        display: none;
      }
    `}
  ${props =>
    props.resolution === "onlyMobile" &&
    css`
      @media (max-width: 480px) {
        display: none;
      }
    `}
`;

const TraderTitle = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`;

const ItemWrapper = styled.div`
  display: table-row;
  width: 100%;
  height: 32px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: ${({ theme }) => theme.foreground};
  background-color: ${({ theme }) => theme.mainDark};

  ${props =>
    props.place === 1 &&
    css`
      color: ${({ theme }) => theme.accent};
    `} ${props =>
  props.place === 2 &&
  css`
    color: #bebebe;
  `} ${props =>
  props.place === 3 &&
  css`
    color: #df9784;
  `};

`;

const ItemNumber = styled.div`
  display: table-cell;
  min-width: 35px;
  margin-right: 8px;
  padding-left: 10px;
  vertical-align: middle;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: bold;
  color: inherit;
`;

const IconBlock = styled.div`
  display: table-cell;
  margin-right: 10px;
  vertical-align: middle;
  color: inherit;

  @media (max-width: 959px) {
    display: none;
  }
`;

const Id = styled.div`
  display: table-cell;
  margin-right: 8px;
  vertical-align: middle;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: 400;
  color: inherit;
`;

const Name = styled.div`
  display: table-cell;
  vertical-align: middle;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: 400;
  color: inherit;

  @media (max-width: 480px) {
    display: none;
  }
`;

const Balance = styled.div`
  display: table-cell;
  margin-right: auto;
  vertical-align: middle;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: 700;
`;

const Reward = styled.div`
  display: table-cell;
  vertical-align: middle;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  font-weight: 700;

  @media (max-width: 959px) {
    display: none;
  }
`;

const Item = props => (
  <ItemWrapper place={props.place}>
    <ItemNumber>#{props.place}</ItemNumber>
    <IconBlock>
      <CupIcon width="16px" />
    </IconBlock>
    <Id>{props.id}</Id>
    <Name>{props.name}</Name>
    <Balance>
      <Money currency={tournamentCurrency} Symbol={Kuchka}>
        {props.balance}
      </Money>
    </Balance>
    <Reward>
      <HowMuchInBucks
        currency={props.currency}
        value={props.reward}
        valueUSD={props.rewardUSD}
      />
    </Reward>
  </ItemWrapper>
);

const DarkRateTable = (props: Object) => (
  <Table>
    <TableTitles>
      <Title type="number">#</Title>
      <Title resolution="onlyDesktop" />
      <Title>
        id<TraderTitle>
          /<Gettext>trader</Gettext>
        </TraderTitle>
      </Title>
      <Title resolution="onlyMobile" />
      <Title>
        <Gettext>Balance</Gettext>
      </Title>
      <Title resolution="onlyDesktop">
        <Gettext>Reward</Gettext>
      </Title>
    </TableTitles>
    {props.leaderboard.items.map(item => (
      <Item
        key={item.place}
        place={item.place}
        id={item.user_id}
        name={item.user_name}
        balance={item.funds_available}
        currency={item.currency}
        reward={item.prize}
        rewardUSD={item.prize_usd}
      />
    ))}
  </Table>
);

export default DarkRateTable;



// WEBPACK FOOTER //
// ./src/components/Tournament/DarkRateTable.js